import { vars } from '@etg/wings';
import { FAILED, MISSED, PENDING, SUCCESS, SUSPENDED, UNKNOWN } from './passnflyStatuses';

export const STATUS_TO_TEXT_KEY = {
  [FAILED]: {
    text: {
      color: vars.colors.signal.critical.dark,
      key: 'OrderDetails.CheckIn.Status.Failed',
    },
    tooltip: {
      color: vars.colors.signal.critical.light,
      key: 'OrderDetails.CheckIn.Status.Failed.Tooltip',
    },
  },
  [MISSED]: {
    text: {
      color: vars.colors.signal.critical.dark,
      key: 'OrderDetails.CheckIn.Status.Failed',
    },
    tooltip: {
      color: vars.colors.signal.critical.light,
      key: 'OrderDetails.CheckIn.Status.Failed.Tooltip',
    },
  },
  [PENDING]: {
    text: {
      color: vars.colors.signal.information.dark,
      key: 'OrderDetails.CheckIn.Status.Pending',
    },
    tooltip: {
      color: vars.colors.signal.information.light,
      key: 'OrderDetails.CheckIn.Status.Pending.Tooltip',
    },
  },
  [SUCCESS]: {
    text: {
      color: vars.colors.signal.positive.dark,
      key: 'OrderDetails.CheckIn.Status.Success',
    },
  },
  [SUSPENDED]: {
    text: {
      color: vars.colors.signal.critical.dark,
      key: 'OrderDetails.CheckIn.Status.Failed',
    },
    tooltip: {
      color: vars.colors.signal.critical.light,
      key: 'OrderDetails.CheckIn.Status.Suspended.Tooltip',
    },
  },
  [UNKNOWN]: {
    text: {
      color: '#737373',
      key: 'OrderDetails.CheckIn.Status.Unknown',
    },
  },
};

export const getCheckInStatusTextKeys = (type) => ({
  PENDING: {
    UPCOMING_BOUND: {
      title: 'OrderDetails.CheckIn.Purchased.Intro.Pending.UpcomingBoundsOnly.Title',
      description: `OrderDetails.CheckIn.Purchased.${type}.Intro.UpcomingFlights`,
    },
    ALL_BOUNDS: {
      title: `OrderDetails.CheckIn.Purchased.${type}.Intro.Pending.AllBounds.Title`,
      description: `OrderDetails.CheckIn.Purchased.${type}.Intro.Pending.Description`,
    },
  },
  SUCCESS: {
    UPCOMING_BOUND: {
      title: 'OrderDetails.CheckIn.Purchased.Intro.Success.Title',
      description: `OrderDetails.CheckIn.Purchased.${type}.Intro.Success.Description`,
      extraInfo: `OrderDetails.CheckIn.Purchased.${type}.Intro.UpcomingFlights`,
    },
    ALL_BOUNDS: {
      title: 'OrderDetails.CheckIn.Purchased.Intro.Success.Title',
      description: `OrderDetails.CheckIn.Purchased.${type}.Intro.Success.Description`,
    },
  },
  PARTIALLY_FAILED: {
    UPCOMING_BOUND: {
      title: 'OrderDetails.CheckIn.Purchased.Intro.PartiallyFailed.Title',
      description: `OrderDetails.CheckIn.Purchased.${type}.Intro.PartiallyFailed.Description`,
      disclaimer: 'OrderDetails.CheckIn.Purchased.Intro.ExtraFeesOnTheAirport',
      extraInfo: `OrderDetails.CheckIn.Purchased.${type}.Intro.UpcomingFlights`,
      notification: 'OrderDetails.CheckIn.Purchased.Failed.SomePassengers.Notification',
    },
    ALL_BOUNDS: {
      title: 'OrderDetails.CheckIn.Purchased.Intro.PartiallyFailed.Title',
      description: `OrderDetails.CheckIn.Purchased.${type}.Intro.PartiallyFailed.Description`,
      disclaimer: 'OrderDetails.CheckIn.Purchased.Intro.ExtraFeesOnTheAirport',
      notification: 'OrderDetails.CheckIn.Purchased.Failed.SomePassengers.Notification',
    },
  },
  FAILED: {
    UPCOMING_BOUND: {
      title: 'OrderDetails.CheckIn.Purchased.Intro.Failed.UpcomingBoundsOnly.Title',
      description: `OrderDetails.CheckIn.Purchased.${type}.Intro.Failed.Description`,
      disclaimer: 'OrderDetails.CheckIn.Purchased.Intro.ExtraFeesOnTheAirport',
      extraInfo: `OrderDetails.CheckIn.Purchased.${type}.Intro.UpcomingFlights`,
      notification: 'OrderDetails.CheckIn.Purchased.Failed.SomePassengers.Notification',
    },
    ALL_BOUNDS: {
      title: 'OrderDetails.CheckIn.Purchased.Intro.Failed.AllBounds.Title',
      description: `OrderDetails.CheckIn.Purchased.${type}.Intro.Failed.Description`,
      disclaimer: 'OrderDetails.CheckIn.Purchased.Intro.ExtraFeesOnTheAirport',
      notification: 'OrderDetails.CheckIn.Purchased.Failed.AllPassengers.Notification',
    },
  },
  UNKNOWN: {
    notice: 'OrderDetails.CheckIn.Status.Unknown.Notice',
  },
});
